// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"ca_a bhv_h bhv_ka bhv_ux bhv_ro bhv_un bhv_rq bhv_rh"};